export const Types = {
    "우울" : "우울",
    "사회불안" : "사회불안",
    "공황\n(신체증상)" : "공황",
    "번아웃" : "번아웃",
    "강박" : "강박",
    "불면" : "불면",
}
const questionList = {
    "우울" : [
        "나는 하루 중 거의 대부분 우울한 기분이 지속된다.",
        "나는 거의 매일 즐거움, 기쁨 등의 감정을 느끼지 못하는 것 같다.",
        "나는 입맛이 줄어 체중이 줄었다.",
        "나에 대한 자책을 자주 한다.",
        "나는 최근 예전과 달리 주의집중을 하는 게 어렵게 느껴진다.",
        "내가 지내는 일상이 가치있게 느껴지지 않는다.",
        "나는 최근 잠을 자는 게 어렵다.",
        "나는 예전과 달리 너무 많은 잠을 잔다.",
        "나는 이유 없이 슬프고, 눈물이 자주 난다.",
        "나는 의욕이 떨어지고 무기력하다.",
    ],
    "사회불안" : [
        "나는 여러 사람 앞에서 음식을 먹거나 대화를 하는 것이 힘들다.",
        "나는 다른 사람들에게 부정적인 평가를 듣게 될까봐 눈치를 본다.",
        "나는 여러 사람들 앞에서 발표하는 것을 어떻게든 피하려고 한다.",
        "나는 여러 사람들 앞에서 말을 할 때 너무 긴장을 해서 숨이 찬 적이 있다.",
        "나는 백화점, 마트 등에 사람이 많을 때 차분히 물건을 고르는 것이 힘들다.",
        "나는 모임과 같이 많은 사람이 있을 때 말을 잘 하지 않는 편이다.",
        "나는 다른 사람들 앞에서 한 실수를 하게 되면 해당 장면이 계속해서 머릿속에 떠오른다.",
        "나는 많은 사람이 모인 곳을 피한다.",
        "나는 지나가는 사람들이 나를 쳐다보는 것 같아 긴장되고 두렵다.",
        "나는 버스나 지하철을 탈 때 사람들이 너무 많으면 목적지에 도착하지 않아도 내린다."
    ],
    "공황\n(신체증상)" : [
        "나는 때때로 맥박이 빨라지거나 심장박동이 강하게 느껴진다.",
        "나는 숨이 가빠지거나 숨이 막히는 것 같은 느낌이 든다.",
        "나는 토할 것 같거나 복부가 불편하다.",
        "나는 현기증을 느끼거나 머리가 묵직하고 띵한 느낌이 든다.",
        "나는 내가 쓰러질까봐 두렵다.",
        "때때로 나는 몸이 마비가 된 것 같은 느낌과 함께 손발이 찌릿찌릿한 느낌이 든다.",
        "나는 내가 있는 현실이 현실이 아닌 것 같은 느낌 혹은 내가 아닌 것 같은 느낌이 든다.",
        "나는 죽을 것 같은 공포가 들 때가 있다.",
        "신체 증상의 불편감으로 인해 장소, 활동에 제약이 많다.",
        "나는 식은땀이 자주 난다."
    ],
    "번아웃" : [
        "나는 예전과 달리 내가 하는 일에 관심이 크게 줄었다.",
        "나는 거의 매일 피로감, 두통, 소화불량 등의 증상을 경험하고 있다.",
        "나는 요즘 나의 학업/ 업무에 지쳐 의욕이 없다.",
        "나는 주변사람들과 일상의 대화를 나눈 것조차 귀찮다.",
        "학교/ 직장에서 사람들과 대화를 하거나 연락을 하는 빈도가 줄었다.",
        "나는 내 삶이 다람쥐 쳇바퀴처럼 매일매일 의미 없이 반복된다고 생각한다.",
        "나는 예전과 달리 점차 한계치에 도달하고 있다는 생각이 자주 든다.",
        "나는 평소와 달리 짜증, 불만을 내는 일이 많아졌다.",
        "나는 예전과 달리 공부/ 일에 대한 능률이 떨어져 제 시간내에 완수하기 힘들다.",
        "나는 내가 하는 일이 의미가 없는 것 처럼 느껴진다.",
    ],
    "불면" : [
        "나는 하루에 특정 시간 이상 동안 잠을 자지 못하면 하루가 망칠 것 같다는 생각이 든다.",
        "나는 숙면을 하지 못하면 건강 등이 나빠질 것 같다는 생각이 들어 불쾌하다.",
        "나는 수면과 관련해서 불편감이 크다.",
        "나는 환경에 따라 수면이 영향을 많이 받는다.",
        "나는 하루에 6시간 이상 잠을 자더라도 다음날 피곤하게 느껴진다.",
        "나는 가위눌림과 같은 증상을 자주 경험한다.",
        "나는 일주일에 2회 이상 잠을 자던 중 깬다.",
        "나는 잠을 자기 전, 1시간 이상 뒤척거리는 일이 잦다.",
        "나는 내가 계획한 수면시간에 잠을 자지 못하면 그날의 수면은 망친것 같은 생각이 든다.",
        "나는 잠을 자기 위해 거의 매일 수면제를 복용하였다."
    ],
    "강박" : [
        "나는 내 의지와 달리 불쾌한 생각들이 반복해서 떠올라 불편하다.",
        "나는 내가 한 일이나 행동에 대해 반복해서 점검한다.",
        "나는 일상적인 일을 할 때에도 절차를 엄격하게 따르는 편이다.",
        "나는 어떤 일을 할 때 다른 사람에 비해서 확인하는 횟수가 많다.",
        "나는 내 생각을 조절하기가 어렵다고 생각한다.",
        "나는 내가 생각한 방식대로 일이 진행되지 않을 때 견디기가 힘들다.",
        "나는 문단속 등을 반복해서 확인해야 안심이 된다.",
        "나는 필요 이상으로 손을 씻는 편이다.",
        "나는 반복해서 드는 불쾌한 생각과 행동 때문에 일상생활에 지장이 있다.",
        "나는 하루 중 반복해서 드는 생각에 몰두하는 시간이 하루에 1시간 이상이다."
    ]
}
/*
    typeQuestionList 와 같은 형태로 만들어줄것
*/
const transform = (questions) => {
    let result = [];
    for(const [symptom, list] of Object.entries(questions)) {
        const items = list?.map((sentence,i)=>({
            sent : sentence,
            type : Types[symptom],
        }));
        result = [...result, ...items];
    }
    console.log(result);
    return result;
}

Object.freeze(questionList);

export const getLength = () => 10;

export default transform(questionList);